import {
  SET_CHANGED_PERMIT_FILTER,
  SET_CHANGE_VISIBLE_PERMIT_FILTER,
  RESET_PERMIT_FILTER,
  SET_SEARCH_VALUE
} from './types';

export const setChangedPermitFilter = (payload) => ({
  type: SET_CHANGED_PERMIT_FILTER,
  payload,
});

export const applyPermitFilter = (type) => (value) => (dispatch) => {
  dispatch(setChangedPermitFilter(true));

  dispatch({
    type,
    payload: value,
  });
};

export const changeVisiblePermitFilter = (payload) => (dispatch) => {
  dispatch(setChangedPermitFilter(false));

  dispatch({
    type: SET_CHANGE_VISIBLE_PERMIT_FILTER,
    payload: payload,
  });
};

export const resetPermitFilter = () => ({
  type: RESET_PERMIT_FILTER,
});

export const setSearchValue = (value) => ({
  type: SET_SEARCH_VALUE,
  payload: value,
});